import * as React from 'react';
import { memo } from 'react';

const SvgFilter2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.083 2.417h5.834v1.166H2.083V2.417ZM.333.083h9.334V1.25H.333V.083Zm3.5 4.667h2.334v1.167H3.833V4.75Z", fill: "currentColor" })));
const Memo = memo(SvgFilter2);

export { Memo as default };
